import { createModalHook } from '../../hooks/useModal'

export const useCloseAccountModal = createModalHook()
export const useReactivateAccountModal = createModalHook()
